import { Classes } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";

import styles from "./teams.tab.module.scss";

export const LoadingTeams = () => {
  // intialize an array of 5 items
  const conferences = Array.from({ length: 5 }, (_, i) => i);

  return (
    <div className={styles.teamsContainer}>
      {conferences.map((conference) => {
        return <LoadingConferenceTeams key={conference} />;
      })}
    </div>
  );
};

export const LoadingConferenceTeams = () => {
  // initialize an array of 15 items
  const teams = Array.from({ length: 15 }, (_, i) => i);

  return (
    <div className={styles.conferenceItem}>
      <div className={styles.conferenceHeader}>
        <div className={classNames(styles.conferenceTitle, Classes.SKELETON)}>Conference Name Filler</div>
      </div>
      <div>
        {teams.map((team) => {
          return <LoadingTeamItem key={team} />;
        })}
      </div>
    </div>
  );
};

const LoadingTeamItem = () => {
  return (
    <div className={styles.teamItem} style={{ backgroundColor: "#fff", cursor: "default" }}>
      <div className={classNames(styles.teamImageContainer, Classes.SKELETON)}>Filler Image</div>
      <div className={classNames(styles.teamName, Classes.SKELETON)}>Filler Team Name</div>
      <div className={classNames(styles.teamPlayCount, Classes.SKELETON)}>1000</div>
    </div>
  );
};
